import { useCallback, useEffect, useState } from "react";

import toast, { Toaster } from "react-hot-toast";
import { connect } from "react-redux";
import { LoginResponseType } from "../../../redux/auth/authTypes";
import {
  CommonHeader,
  ConfirmationModal,
  EmptyListPage,
  ErrorSuccessModal,
  TableLoader,
} from "../../../components/commons";
import { EmptyList } from "../../../assets/images";
import { RootState } from "../../../redux/rootReducers";
import { resetSession } from "../../../redux/auth";
import {
  changeBatchStatusAction,
  getBatchManagementAction,
  resetBatchManagementList,
  resetBatchManagementListTotalCount,
  resetClientSettingsError,
  resetClientSettingsSuccess,
  resetMessage,
} from "../../../redux/clientSettings";
import BatchManagementTable from "../../../components/ClientSettings/BatchManagement/BatchManagementTable";
import { BATCH_MANAGEMENT_HEADER } from "../../../constant/tableHeadersConstants/clientSettingsconstants/batchManagementHeader";
import { resetMasterStatusCode } from "../../../redux/masterData";
import {
  ChangeStatusBatchListPayloadType,
  GetBatchListPayloadType,
} from "../../../commonTypes/clientSettingsTypes";
import { BatchManagementItem } from "../../../redux/clientSettings/clientSettingTypes";
import { SearchIcon } from "../../../components/Icon";
import BatchManagementFilter, { BATCH_STATUS_RADIO_OPTIONS } from "./BatchManagementFilter";
import useDebounce from "../../../customHooks/useDebounce";
import { RadioTypes } from "../../../commonTypes/universalTypes";

type AppProps = {
  history: any;
  fetching: boolean;
  message: string | null;
  success: null | number;
  error: null | string;
  statusCode: null | number;
  token: null | string;
  dispatchResetSession: () => void;
  batchManagementListTotalCount: number;
  dispacthResetBatchManagementListTotalCount: () => void;
  loginData: LoginResponseType;
  dispatchGetBatchMangementAction: (data: GetBatchListPayloadType) => void;
  dispatchResetBatchManagementList: () => void;
  batchManagementList: BatchManagementItem[] | [];
  dispatchResetClientSettingMessage: () => void;
  dispatchResetMasterStatusCode: () => void;
  dispatchResetClientSettingsSuccess: () => void;
  dispatchResetClientSettingsError: () => void;
  dispatchChangeBatchStatusAction: (
    data: ChangeStatusBatchListPayloadType
  ) => void;
};
const BatchManagement = ({
  history,
  fetching,
  message,
  success,
  error,
  token,
  statusCode,
  loginData,
  dispatchResetSession,
  dispatchGetBatchMangementAction,
  batchManagementList,
  dispatchResetBatchManagementList,
  dispatchResetClientSettingMessage,
  dispatchResetMasterStatusCode,
  dispatchResetClientSettingsSuccess,
  dispatchResetClientSettingsError,
  dispatchChangeBatchStatusAction,
  batchManagementListTotalCount,
  dispacthResetBatchManagementListTotalCount,
}: AppProps) => {
  const client_code = history?.location?.state?.client_code;
  const company_name = history?.location?.state?.company_name;
  const [showConfirmationModal, setShowConfirmationModal] =
    useState<boolean>(false);
  const [confirmationModalData, setConfirmationModalData] = useState<any>({
    is_enable: null,
    batch_id: "",
  });
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [data, setData] = useState<[] | any[]>([]);
  const [searchData, setSearchData] = useState("");
  
  // Filter
  const [enableStatus, setEnableStatus] = useState<string>("");
  const [enableStatusValue, setEnableStatusValue] = useState<string>("");
  const [clearFilter, setClearFilter] = useState<boolean>(false);
  const [multiSelectData, setMultiSelectData] = useState<any>([]);


  useEffect(() => {
    dispatchResetClientSettingMessage();
    dispatchResetClientSettingsSuccess();
    dispatchResetClientSettingsError();
    dispatchResetBatchManagementList();
    dispacthResetBatchManagementListTotalCount();
  }, []);

  useEffect(() => {
    if (batchManagementList?.length === 0) {
      setData(batchManagementList);
    }
    if (offset > 0) {
      setData((prv: any) => [...prv, ...batchManagementList]);
    } else {
      setData(batchManagementList);
    }
  }, [batchManagementList]);

  useEffect(() => {
    if (token) {
      let finalData = {
        token,
        clientCode: client_code,
        limit,
        offset,
        search_term: searchData,
        is_enable: enableStatus
      };

      if(clearFilter){
        finalData.is_enable="";
        setEnableStatus("");
        setEnableStatusValue("");
        setClearFilter(false);
      }

      if (batchManagementListTotalCount) {
        if (offset < +batchManagementListTotalCount) {
          dispatchGetBatchMangementAction(finalData);
        
        }
      } else {
        dispatchGetBatchMangementAction(finalData);

      }
    }
  }, [offset, clearFilter]);


  useDebounce(() => {
    if(searchData) {
      fetchNewData();
    } else{
      let finalData = {
        token,
        limit,
        offset,
        search_term: searchData,
        is_enable: enableStatus,
        clientCode: client_code,
      };
      dispatchGetBatchMangementAction(finalData);

    }
  }, 500, [searchData]);

  const fetchNewData = () => {
    if(token) {
      let finalData = {
      token,
      limit,
      offset,
      search_term: searchData,
      is_enable: enableStatus,
      clientCode: client_code,
    };
    if (offset === 0){
      dispatchGetBatchMangementAction(finalData);

    } else {
      setOffset(0);
    }
  }
};


  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        offset < batchManagementListTotalCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (batchManagementList?.length > 0) {
          if (!fetching && offset < batchManagementListTotalCount) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [batchManagementList]);

  useEffect(() => {
    if (offset === 0) {
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, 0);
      setOffset(0);
    }
  }, [success]);

  useEffect(() => {
    dispacthResetBatchManagementListTotalCount();
    dispatchResetBatchManagementList();
    setOffset(0);
    getData();
    if(enableStatus || !enableStatus){
      if(offset === 0 && token){

        let finalData = {
          token,
          limit,
          offset,
          search_term: searchData,
          is_enable: enableStatus,
          clientCode: client_code,
        };
        dispatchGetBatchMangementAction(finalData);

      }
    }
  }, [enableStatus]);

  const getData = useCallback(() => {
    const getBatchStatusValue = BATCH_STATUS_RADIO_OPTIONS.find(
      (item: RadioTypes) => String(item.id) === String(enableStatus)
    );
    setMultiSelectData([getBatchStatusValue]);
  }, [enableStatus]);

  useEffect(() => {
    if (
      message?.includes("Batch status has changed successfully") ||
      message?.includes("Batch status has changed successfully")
    ) {
      dispatchResetBatchManagementList();
      dispatchResetClientSettingsError();
      dispatchResetClientSettingMessage();
      toast.success(
        `Batch has been changed successfully`,

        {
          duration: 2000,
        }
      );
   

    }
  }, [message]);
  const handleRedirectToEditForm = (data: any) => {
    window.scrollTo(0, 0);
    history.push({
      pathname: `/client-settings/batch-management/${client_code}/edit/${data?.batch_id}`,
      state: {
        company_name,
        client_code,
      },
    });
  };
  const handleChangeCustomerSupplierStatus = (currentData: any) => {
    if (token && confirmationModalData?.batch_id) {
      let updateData = {
        token,
        batch_id: confirmationModalData?.batch_id,
        is_enable: confirmationModalData?.is_enable === 1?0:1,
      };
      dispatchChangeBatchStatusAction(updateData);
    }
  };

  const handleEnableDisableStatus = (data: any) => {
    setShowConfirmationModal(true);
    setConfirmationModalData({ ...data });
  };
  const handleConfirmationModal = () => {
    setShowConfirmationModal(!showConfirmationModal);
  };

  const handleSearch = (e: any) => {
    let value = e.target.value;
    setSearchData(value);

    if(value?.length === 0) {
      let finalData = {
        token,
        offset: 0,
        limit,
        clientCode: client_code,
        is_enable: enableStatus,
      };
      dispatchGetBatchMangementAction(finalData);

    }
  }

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetClientSettingsError();
            }}
          />
        );
      }
    }

    if (success === 1 && message == "Batch has been added successfully!") {
   
      dispatchResetClientSettingsSuccess();
      dispatchResetClientSettingMessage();

      if (token) {
        if (offset === 0) {
          let finalData = {
            search_term: searchData,
            token,
            is_enable: enableStatus,
            clientCode: client_code,
            limit,
            offset

          };
          dispatchGetBatchMangementAction(finalData);

        }else{
          setOffset(0)
        }
      }
    }

    if (success === 1 && message == "Batch has been updated successfully!") {
      let finalData ={
        search_term: searchData,
        token, 
        is_enable: enableStatus,
        clientCode: client_code,
        offset: 0,
        limit
      }
      if(offset===0){

        dispatchGetBatchMangementAction(finalData);

      }
      else{
        setOffset(0)
      }
      dispatchResetClientSettingsSuccess();
      dispatchResetClientSettingMessage();

    }


    if (success === 1 && message == "Batch status has changed successfully") {
     
      dispatchResetClientSettingsSuccess();
      dispatchResetClientSettingMessage();
    
      if (token) {
        if (offset === 0) {
          let finalData = {
            search_term: searchData,
            token,
            is_enable: enableStatus,
            clientCode: client_code,
            limit,
            offset
          };
          dispatchGetBatchMangementAction(finalData);

        }else{
          setOffset(0)
        }
      }
    }

    return false;
  };
  return (
    <div className="row">
      <div className="col-md-6 mb-3">
        <CommonHeader
          title="Batch Management"
          company_name={company_name}
          client_code={client_code}
        />
      </div>
      <div className="col-md-6 text-right">
              <button
                onClick={() =>
                  history?.push({
                    pathname: `/client-settings/batch-management/${client_code}/add`,
                    state: { client_code, company_name },
                  })
                }
                className="btn btn-primary"
              >
                + Add Batch
              </button>
            </div>
      <div className="col-md-12 mt-4">
        <div className="jobs-card">
          <div className="header">
            <div className="left-header">
              <div className="heading">Batch List</div>
              {!fetching && (
                <div
                  className="sub-heading"
                  style={{ marginTop: "-22px" }}
                >{`Total ${
                  batchManagementListTotalCount
                    ? batchManagementListTotalCount
                    : 0
                } batch found`}</div>
              )}
            </div>
            <div className="text-right d-flex flex-row col-lg-8"
              style={{ justifyContent: "flex-end" }}>
                  <div
                    className="mr-2 w-auto position-relative"
                  >
                    <span
                      style={{ position: "absolute", top: "8px", left: "13px" }}
                    >
                      <SearchIcon />
                    </span>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Search"
                      onChange={(e) => handleSearch(e)}
                      style={{ paddingLeft: "35px" }}
                      value={searchData}
                    />
                  </div>
                  <div className="form-group mr-1">
                    <BatchManagementFilter
                      activeStatus={enableStatus}
                      setActiveStatus={setEnableStatus}
                      activeStatusValue={enableStatusValue}
                      setActiveStatusValue={setEnableStatusValue}
                      setClearFilter={setClearFilter}
                      setOffset={setOffset}
                      setData={setData}
                    />
                  </div>
            </div>
          </div>
          <div>
            {fetching  && offset == 0 ? (
              <TableLoader Rows={10} ColumnPerRow={7} />
            ) : batchManagementList?.length > 0 ? (
              <BatchManagementTable
                data={data}
                fetching={fetching}
                offset={offset}
                // tableHeaders={BATCH_MANAGEMENT_HEADER}
                handleRedirectToEditForm={handleRedirectToEditForm}
                handleEnableDisableStatus={handleEnableDisableStatus}
              />
            ) : (
              <div className="mt-5 pb-5">
                {!fetching && batchManagementList?.length === 0 && (
                  <EmptyListPage
                    title="No Batch List Found!"
                    image={EmptyList}
                    imageWidth="30%"
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {showConfirmationModal && confirmationModalData?.batch_id && (
        <ConfirmationModal
          toggle={() => {
            handleConfirmationModal();
          }}
          isOpen={showConfirmationModal}
          title={`${
            !confirmationModalData?.is_enable ? "Enable" : "Disable"
          } Batch ?`}
          message={`Are you sure you want to ${
            !confirmationModalData?.is_enable ? `Enable ` : `Disable`
          }?`}
          confirmButtonText={
            confirmationModalData?.is_enable ? "Disable" : "Enable"
          }
          onPressConfirm={() => {
            handleChangeCustomerSupplierStatus(confirmationModalData);
            handleConfirmationModal();
          }}
        />
      )}

      <Toaster />
      {handleErrorModal()}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  success: state.clientSettings.success,
  fetching: state.clientSettings.fetching,
  message: state.clientSettings.message,
  statusCode: state.clientSettings.statusCode,
  error: state.clientSettings.error,
  batchManagementList: state.clientSettings.batchManagementList,
  loginData: state.auth.loginData,
  batchManagementListTotalCount:
    state.clientSettings.batchManagementListTotalCount,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchGetBatchMangementAction: (data: GetBatchListPayloadType) =>
    dispatch(getBatchManagementAction(data)),
  dispatchResetBatchManagementList: () => dispatch(resetBatchManagementList()),
  dispatchResetClientSettingMessage: () => dispatch(resetMessage()),
  dispatchResetMasterStatusCode: () => dispatch(resetMasterStatusCode()),
  dispatchResetClientSettingsSuccess: () =>
    dispatch(resetClientSettingsSuccess()),
  dispatchResetClientSettingsError: () => dispatch(resetClientSettingsError()),
  dispatchChangeBatchStatusAction: (data: ChangeStatusBatchListPayloadType) =>
    dispatch(changeBatchStatusAction(data)),
  dispacthResetBatchManagementListTotalCount: () =>
    dispatch(resetBatchManagementListTotalCount()),
});

export default connect(mapStateToProps, mapDispatchToProps)(BatchManagement);
